import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	changePasswordThunk,
	changeTransactionPasswordRequestThunk,
	changeTransactionPasswordThunk,
	getBankDetailsThunk,
	getKYCDataThunk,
	getUserProfileData,
	updateBankDetailsThunk,
	updateUserKycDataThunk,
	updateUserProfileDataThunk,
} from './personalDetailsApi'

const initialState = {
	profileData: null,
	kycData: null,
	bankData: null,
}

export const fetchUserProfile = createAsyncThunk('user/fetchUserProfile', getUserProfileData)

export const updateUserProfileData = createAsyncThunk('user/updateUserProfileData', updateUserProfileDataThunk)

export const getUserKycData = createAsyncThunk('user/getUserKycData', getKYCDataThunk)
export const updateUserKycData = createAsyncThunk('user/updateUserKycData', updateUserKycDataThunk)

export const fetchUserBankData = createAsyncThunk('user/updateUserBankData', getBankDetailsThunk)
export const updateBankData = createAsyncThunk('user/updateBankData', updateBankDetailsThunk)

export const changePassword = createAsyncThunk('user/changePassword', changePasswordThunk)
export const changeTransactionPasswordRequest = createAsyncThunk('user/changeTransactionPassword', changeTransactionPasswordRequestThunk)

export const changeTransactionPassword = createAsyncThunk('user/changeTransactionPassword', changeTransactionPasswordThunk)

export const userProfileSlice = createSlice({
	name: 'userProfile',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUserProfile.fulfilled, (state, action) => {
				state.profileData = action.payload // Update the state with the profile data
			})
			.addCase(getUserKycData.fulfilled, (state, action) => {
				state.kycData = action.payload // Update the state with the profile data
			})
			.addCase(fetchUserBankData.fulfilled, (state, action) => {
				state.bankData = action.payload // Update the state with the profile data
			})
	},
})
export const { setUserProfileData } = userProfileSlice.actions
export default userProfileSlice.reducer
